import { EditShippingAddress as EditShippingAddressShared } from '../../../../components/Containers/ReviewCheckoutDrawer/ShippingAddress/EditShippingAddress';
import { useFlow } from '../../../../providers';
import { usePreAuthOfferCtx } from '../../../../providers/PreAuthOfferProvider';

export const EditShippingAddress = () => {
  const { goPrevStep, goToStep } = useFlow();
  const { addresses, handleAddressUpdate, selectedAddressId } =
    usePreAuthOfferCtx();

  return (
    <EditShippingAddressShared
      addresses={addresses?.addresses || []}
      onAddressUpdate={async (addressId) => {
        if (addressId) {
          await handleAddressUpdate(addressId);
          goToStep('apply');
        }
      }}
      onCancel={goPrevStep}
      selectedAddress={selectedAddressId}
    />
  );
};
